import { useEffect, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import CallAPI,{CallAPIform} from "../api";
import Swal from "sweetalert2";
import {account_type} from '../constants';
export default function useProfile(){
    const [control,setControl]=useState();
    const [details,setDetails]=useState();
    const [loading,setLoading]=useState(false);
    const [dploading,setdploading]=useState(false);
    const [finaldetails,setFinalDetails]=useState();
    const [initalloading,setinitialloading]=useState(false)
   ;
   const navigate=useNavigate()
  useEffect(()=>{

  setinitialloading(true);
   let  accountType=localStorage.getItem("accountType");
   let  _id=localStorage.getItem("_id");
     if(!accountType)
     navigate("/")
   async function fetch(){
    try {
      const profileres=await CallAPI(`${accountType}/details?_id=${_id}`);
      setDetails(profileres.data);
      setFinalDetails(profileres.data);
      if(accountType!==account_type.USER){
      const pres=await  CallAPI(`${accountType}/permission?_id=${_id}`);
      setControl(pres.data);
      }
    } catch (error) {
        console.log(error);
    }
    setinitialloading(false)
   }
   if(accountType && _id)
  fetch();
  },[])

 
  const handleChangeDetails=(field,value)=>{
   setFinalDetails(prev=>{
    const obj={...prev};
    obj[field]=value;
    return obj;
   })
  }

  const submitDetails=async ()=>{
   
    setLoading(true);
    try {
        const data={};
        for(let el in finaldetails)
        if(details[el]!==finaldetails[el])
        data[el]=finaldetails[el];
         delete data.profileurl;
      const isEmpty=  Object.keys(data).length === 0;
      if(isEmpty)
      {
        setLoading(false);
        return;
      }
       const res=await CallAPI(`${details.accountType}/update`,"post",{...data,_id:details._id});
       Swal.fire("Success",res.message,"success");
    } catch (error) {
        console.log(error);
    }
    setLoading(false);
  }

 
  const changeDp=async(e)=>{
    setdploading(true);
try {
    if(e.target.files[0])
    {
   // const tempUrl=URL.createObjectURL(e.target.files[0]);
   // handleChangeDetails("profileurl",tempUrl);
    const form=new FormData();
    form.append('photo',e.target.files[0]);
    form.append('_id',details._id);
    const res=await CallAPIform(`${details.accountType}/changedp`,"post",form);
    handleChangeDetails("profileurl",res.data);
    }
} catch (error) {
   console.log(error); 
}
setdploading(false);
  }

  return {finaldetails,loading,dploading,control,handleChangeDetails,submitDetails,changeDp,initalloading};
}